/*
 * Copyright (C) 2017-2019 HERE Europe B.V.
 * Licensed under Apache 2.0, see full license in LICENSE
 * SPDX-License-Identifier: Apache-2.0
 */

/** @hidden */
export const appId = "devportal-demo-20180625";

/** @hidden */
export const appCode = "9v2BkviRwi9Ot26kp2IysQ";

/** @hidden */
export const accessToken = "AYlqpxvwl7C8tSVG22lX2lg";
